export const events = {
  viewPricingPlans: 'View Pricing plans',
  goToPricingPlans: 'Go to Pricing plans',
  upgradePlanCancel: 'Upgrade plan cancel',
  upgradePlanStart: 'Upgrade plan start',
  upgradePlanAddBillingPaymentInfo: 'Upgrade plan add billing and payment info',
  upgradePlanSuccess: 'Upgrade plan sucess',
  upgradePlanError: 'Upgrade plan error',
  viewedHub: 'View a hub',
  addedAModule: 'Added a module',
  removedAModule: 'Removed a module',
  openPlansComparison: 'Open sidepanel plans comparison',
  requestToUpgradeStart: 'Request to upgrade start',
  viewedLockModal: 'Viewed lock modal',
  viewCustomBundlesPage: 'View custom bundles page',
  openOnboardingCalendar: 'Open onboarding booking calendar',
  visitTrialFeaturesComparison: 'View trial features comparison table',
  addedPlanUpsell: 'Added plan upsell',
}
